import NavMenu from "app/components/NavMenu";
import Table from "app/components/Table";
import React, { useEffect, useMemo } from "react";
import Rows from "./Rows";
import { TableHeader } from "app/components/Table/types";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actions } from "../../../redux/slice";
import { useSelector } from "react-redux";
import { selectBoards, selectIsLoading, selectSortByColumn, selectSortByOrder } from "../../../redux/selector";
import { sortOrder } from "app/types";
import StickyTable from "app/components/Table/sticky-table";
import { selectUserFormData } from "app/redux/selector";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import { actions as memberActions } from "app/containers/Features/components/MemberSelection/redux/slice";
import { filterMyBoards } from "../../../helpers";


const headers: TableHeader[] = [
  {
    name: "Board name",
    id: "name",
    align: "left",
    sortable: true,
  },
  {
    name: "Last viewed",
    id: "lastViewed",
    align: "left",
  },
  {
    name: "Last updated",
    id: "lastUpdated",
    align: "left",
  },
  {
    name: "Owner",
    id: "owner",
    align: "left",
  },
  {
    name: "Date created",
    id: "createdAt",
    align: "left",
  },
];

export default function List() {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const params = useParams();
  const dispatch = useDispatch();
  const sortByColumn = useSelector(selectSortByColumn);
  const sortByOrder = useSelector(selectSortByOrder);
  const boards = useSelector(selectBoards);
  const loading = useSelector(selectIsLoading);
  const currentUser = useSelector(selectUserFormData);
  const projectMembers = useSelector(selectProjectMemberList);
  const type = searchParams.get("type") || "all";

  useEffect(() => {
    if (!params.project) {
      return;
    }
    dispatch(
      memberActions.fetchProjectMembersList({
        id: params.project,
        callback() {},
      }),
    );
  }, [dispatch, params.project]);

  const visibleBoards = useMemo(() => {
    if (type !== "my-boards") {
      return boards;
    }
    return filterMyBoards(boards, currentUser?._id, projectMembers);
  }, [boards, type, currentUser?._id, projectMembers]);
  const options = useMemo(() => {
    return [
      {
        title: "all",
        icon: null,
        link: `${pathname}?type=all`,
        isActive: type === "all",
      },
      {
        title: "my boards",
        icon: null,
        link: `${pathname}?type=my-boards`,
        isActive: type === "my-boards",
      },
    ];
  }, [type, pathname]);

  const handleSort = (sortBy:string) => {
    const newSortOrder = sortByOrder === sortOrder.ASC ? sortOrder.DESC : sortOrder.ASC;
    dispatch(actions.setSortByColumn(sortBy));
    dispatch(actions.setSortByOrder(newSortOrder));
    dispatch(actions.setSortedBoardsData());
  };
  return (
    <div className="flex flex-col gap-[10px] ">
      <NavMenu options={options} />
      <div className=" ">
        <StickyTable 
          className="w-full min-w-0 h-[calc(100vh-500px)] overflow-y-auto overflow-x-auto"
          headers={headers} 
          handleSort={handleSort}
          sortByOrder={sortByOrder}
          sortByColumn={sortByColumn}
          loading={loading}
          isShowActions
          actionsHeadClassName=" !min-w-[16px] !max-w-[16px] !p-0 relative z-20 w-[16px] "
          headerClassName=" !top-0  h-[52px]"
          emptyText="There are no any boards"
        >
          {visibleBoards.length > 0 && <Rows boards={visibleBoards} />}
         
        </StickyTable>
      </div>
    </div>
  );
}
